module.exports = __webpack_public_path__ + "img/ZV.c22b14ec.png";